import { useCallback, useMemo } from 'react';

import { CrmObject, FolderProps } from 'framework-listing-lib/types';
import { useCrmObjectType } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
import { useHasViews } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { useHasFoldersMode } from 'framework-listing-lib/internal/hooks/useUIMode';

export default function useFolderProps() {
  'use memo';
  const { folderProps } = useCrmObjectType();

  return useMemo<FolderProps>(() => {
    if (!folderProps) {
      return {};
    }

    return folderProps;
  }, [folderProps]);
}

export function useHasFoldersTab() {
  'use memo';
  const hasViews = useHasViews();
  const hasFoldersMode = useHasFoldersMode();

  return useMemo(() => hasViews && hasFoldersMode, [hasFoldersMode, hasViews]);
}

export function useOnSelectFolder() {
  'use memo';
  const { onSelectFolder } = useFolderProps();

  return useCallback(
    (crmFolder: CrmObject) => {
      if (onSelectFolder) {
        onSelectFolder(crmFolder);
      }
    },
    [onSelectFolder]
  );
}

export function useHiddenFolderFilter() {
  'use memo';
  const { hiddenFilter } = useFolderProps();

  return hiddenFilter;
}

export function useHideFolderAssetCount() {
  'use memo';
  const { hideFolderAssetCount } = useFolderProps();

  return hideFolderAssetCount ?? false;
}
